import moment from "moment";
import { Person, Team, TeamMember } from "../../models";
import { getTeamMembersByCreatorId, getTeamMembersByPersonId } from "../teamMember/TeamMember";
import { getAllTeams } from "./Team";
import { sortTeamsByCreatedDate } from "./SortTeams";

const checkIfTeamIsCurrent = (team: Team) => {
    const startOfSeason: string =  "2026-06-01";
    const endOfSeason: string = "2027-05-31";
    const dateTeamCreated: string = team.createdOn;
    const isTeamCurrent: boolean = moment(dateTeamCreated).isBetween(startOfSeason, endOfSeason);
    return isTeamCurrent;
}

export const getAllCurrentTeams = async () => {
    const teamsQuery = await getAllTeams();
    if (teamsQuery.isSuccess) {
        const teamsList: Team[] = teamsQuery.result;

        // Filter the teams to only include current teams
        const currentTeamsList: Team[] = teamsList.filter(t => checkIfTeamIsCurrent(t));

        // Sort the teams by created date
        const sortedTeamsByDate = sortTeamsByCreatedDate(currentTeamsList);
        return sortedTeamsByDate;
    }
    return [];
};

export const getTeamsForCurrentUser = async (currentUser: Person, isOnlyCurrentTeams: boolean) => {
    // Create a list of teams that the current user is a member of
    let teamList: Team[] = [];

    // Check for TeamMembers with the current user's ID listed as the personId
    const teamMembersWithCurrentUserIdQuery = await getTeamMembersByPersonId(currentUser.id);
    if (teamMembersWithCurrentUserIdQuery.isSuccess) {
        const teamMembersList: TeamMember[] = teamMembersWithCurrentUserIdQuery.result;
        teamMembersList.forEach((tm) => {
            if (tm.team) {
                const currentTeam = tm.team;
                const alreadyInTeamList = teamList.find(t => t.id === currentTeam.id);
                if (!alreadyInTeamList) {
                    if (isOnlyCurrentTeams) {
                        if (checkIfTeamIsCurrent(currentTeam)) {
                            teamList.push(currentTeam);
                        }
                    } else {
                        teamList.push(currentTeam);
                    }
                }
            }
        });
    }

    // Check for TeamMembers with the current user's ID listed as the creatorId (example: a parent is looking for the team they signed up their child for)
    const teamMembersCreatedByCurrentUserQuery = await getTeamMembersByCreatorId(currentUser.id);
    if (teamMembersCreatedByCurrentUserQuery.isSuccess) {
        const teamMembersList: TeamMember[] = teamMembersCreatedByCurrentUserQuery.result;
        teamMembersList.forEach((tm) => {
            if (tm.team) {
                const currentTeam = tm.team;
                const alreadyInTeamList = teamList.find(t => t.id === currentTeam.id);
                if (!alreadyInTeamList) {
                    if (isOnlyCurrentTeams) {
                        if (checkIfTeamIsCurrent(currentTeam)) {
                            teamList.push(currentTeam);
                        }
                    } else {
                        teamList.push(currentTeam);
                    }
                }
            }
        });
    }

    // Sort the teams by created date
    const sortedTeamsByDate = sortTeamsByCreatedDate(teamList);
    return sortedTeamsByDate;
};

export const getTeamMembersForCurrentUser = async (personId: string, isOnlyCurrentTeams: boolean) => {
    const teamMembersWithCurrentUserIdQuery = await getTeamMembersByPersonId(personId);
    if (teamMembersWithCurrentUserIdQuery.isSuccess) {
        const teamMembersList: TeamMember[] = teamMembersWithCurrentUserIdQuery.result;

        // Create a list of teams that the current user is a member of
        let teamMemberList: TeamMember[] = [];
        teamMembersList.forEach((tm) => {
            if (tm.team) {
                const currentTeam = tm.team;
                const alreadyInTeamList = teamMemberList.find(teamMem => teamMem.team.id === currentTeam.id);
                if (!alreadyInTeamList) {
                    if (isOnlyCurrentTeams) {
                        if (checkIfTeamIsCurrent(currentTeam)) {
                            teamMembersList.push(tm);
                        }
                    } else {
                        teamMembersList.push(tm);
                    }
                }
            }
        });

        // Sort the teams by created date
        return teamMembersList;
    }
    return [];
};